
































import VueOptions from '@utils/VueOptions'

settings = 
  name: "TeamShow"
  resources: 
    team: 
      resourceName: "supplier"
      slug: "team"
  vue: {}
export default VueOptions.vue settings
